<template>
  <JobsPage :articles="articles" />
</template>

<script setup>
import { useJobsStore } from '~/stores/jobs';

useHead({
  title: 'Browse remote tech jobs – Proxify Careers',
  meta: [
    {
      key: 'og:title',
      property: 'og:title',
      content: 'Browse remote tech jobs – Proxify Careers',
    },
  ],
});

const { $cmsApi } = useNuxtApp();
const jobsStore = useJobsStore();

const { data } = await useAsyncData(async () => {
  let jobs = jobsStore.jobs;

  const articles = await $cmsApi.get('/articles/career-path');

  if (!jobs.length) {
    jobs = await $cmsApi.get('/public-jobs');
    jobsStore.setJobs(jobs);
  }

  return {
    articles,
  };
});

const articles = data.value?.articles || [];
</script>
